import { DEFAULT_LOGO, DEFAULT_LOGO_ALT } from '../../config/defaultLogo';

/**
 * RLinkLogo - Consistent logo used across the app.
 * Shows R-Link Studio logo by default, or white-label logo if provided.
 *
 * @param {string}  size       - "sm" | "md" | "lg" | "xl" (default "md")
 * @param {boolean} showText   - (kept for API compat)
 * @param {string}  textLabel  - (kept for API compat)
 * @param {string}  className  - Extra wrapper classes
 * @param {string}  companyLogo - White-label logo URL (if set, renders user logo instead)
 * @param {string}  companyName - White-label company name for alt text
 */
export default function RLinkLogo({
  size = "md",
  showText = true,
  textLabel,
  className = "",
  companyLogo,
  companyName,
}) {
  const imgStyles = {
    sm:  { height: "28px",  maxWidth: "140px" },
    md:  { height: "32px",  maxWidth: "140px" },
    lg:  { height: "40px",  maxWidth: "280px" },
    xl:  { height: "auto",  maxWidth: "min(440px, 80vw)", maxHeight: "160px" },
  };

  // White-label logo takes priority, otherwise use default R-Link Studio logo
  const logoSrc = companyLogo || DEFAULT_LOGO;
  const altText = companyName || DEFAULT_LOGO_ALT;

  return (
    <img
      src={logoSrc}
      alt={altText}
      className={`w-auto object-contain ${className}`}
      style={imgStyles[size] || imgStyles.md}
    />
  );
}
